import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function initBackgroundSwitch() {
  const body = document.body
  
  // Get all sections with data-bg-color attribute
  const sections = document.querySelectorAll<HTMLElement>('[data-bg-color]')

  if (sections.length === 0) {
    console.warn('No sections with data-bg-color found')
    return
  }

  sections.forEach((section) => {
    const bgColor = section.dataset.bgColor!
    const textColor = section.dataset.textColor || '#1d1c1b'

    ScrollTrigger.create({
      trigger: section,
      start: 'top 50%',
      end: 'bottom 50%',
      onToggle: (self) => {
        if (self.isActive) {
          // Use gsap.set to immediately set the color (no animation interruption issues)
          // The CSS transition on body handles the smooth animation
          body.style.backgroundColor = bgColor
          body.style.color = textColor
        }
      },
    })
  })

  console.log('Background switch initialized')
}
